import { apiGet } from '@/lib/http/client';

import type { ActiveCampaignStatusResponse } from '../types';

export async function getActiveCampaignStatus(
  orgId: number | string
): Promise<ActiveCampaignStatusResponse> {
  return apiGet<ActiveCampaignStatusResponse>(
    `/api/orgs/${orgId}/activecampaign/status/`
  );
}
